<template>
  <app-layout class="advocay-template">
    <!-- <Affix v-if="this.$route.params.groupType != 'interest'" :offset-top="60">
      <Card shadow :padding="10" :style="{borderRadius: '0'}">
        <div class="ivu-input-wrapper ivu-input-type">
          <i class="ivu-icon ivu-icon-search ivu-input-icon ivu-input-icon-normal"></i>
          <input autocomplete="off" spellcheck="false" type="text" placeholder="Search..."
            v-model="filter"
            class="ivu-input">
        </div>
      </Card>
    </Affix> -->
    <div v-if="this.$route.params.groupType == 'interest' && !isPeople">
      <div v-if="orderedFeatured.length != 0" style="margin:4px">
        <h4>Featured</h4>
      </div>
      <Row type="flex" justify="center">
        <Col :span="24" v-for="(item, k) in orderedFeatured" :key="k">
          <ResourceListItemComponent :item="item"></ResourceListItemComponent>
        </Col>
      </Row>
      <div v-if="orderedOthers.length != 0" style="margin:4px">
        <h4>Others</h4>
      </div>
      <Row type="flex" justify="center">
        <Col :span="24" v-for="(item, k) in orderedOthers" :key="k">
          <ResourceListItemComponent :item="item"></ResourceListItemComponent>
        </Col>
      </Row>
    </div>
    <Row v-else type="flex" justify="center">
      <!-- <Col v-show="isLoadingResources">
        <p align="center"><i class="fa fa-spin fa-spinner" /> Loading...</p>
      </Col> -->
      <Col v-show="!isLoadingResources" :span="24" v-for="(item, k) in orderedSelections" :key="k">
        <ResourceListItemComponent :item="item"></ResourceListItemComponent>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
import _ from 'lodash'
import ResourceListItemComponent from '@/components/ResourceMainAdvocaciesComponent'

export default {
  name: 'ResrouceByType',
  components: {
    ResourceListItemComponent
  },
  props:{
    type: String, required: false, default: "default"
  },
  data() {
    return {
      filter: '',
      isLoadingResources: false
    }
  },
  watch: {
    '$route': function(n) {
      if( n ) {
        if(this.$route.params.groupType == 'event'){
          this.$store.dispatch('events/getAllEvents', 1)
        } else if(n & n.params & n.params.groupType == "interest")
          this.$store.dispatch('user/getResourceInterest', {type: this.$route.params.groupType});
        } else{
          this.$store.dispatch('user/getResourceByType', {type: this.$route.params.groupType});
        }
    }
  },
  computed: {
    userInfo: {
      get() { return this.$store.state.user.info }
    },
    resrouceByType: {
      get() {
        return this.$store.state.user.resrouceByType["any"]
      }
    },
    events: {
        get() {
          return this.$store.state.events.events.data;
        }
    },
    careplan: function() {
      var list = [];
      if (this.resrouceByType) {
        list = (this.resrouceByType.hasOwnProperty('careplan')) ? this.resrouceByType.careplan:[];
      }
      return list;
    },
    orderedSelections: function () {
      if(this.$route.params.groupType == 'event'){
        var list =  this.events.filter((list) => {
          return list.title.toLowerCase().includes(this.filter.toLowerCase());
        });
        return _.orderBy(list,'label');
      }else  {
        var list = this.careplan.filter((list) => {
          return list.title.toLowerCase().includes(this.filter.toLowerCase());
        });
        return _.orderBy(list,'label');
      }
    },
    orderedFeatured: function () {
      var list = this.careplan.filter((list) => {
        return list.is_featured;
      });
      return list
    },
    orderedOthers: function () {      
      var list = this.careplan.filter((list) => {
        return !list.is_featured;
      });
      return list
    },
    isPeople: function () {
      return this.$route.query.type == 'people'
    }
  },
  mounted() {
      if(this.$route.params.groupType == 'event'){
        this.$store.dispatch('events/getAllEvents', 1)
      }else if(this.$route.params.groupType == 'interest') {
        this.$store.dispatch('user/getResourceInterest', {type: this.$route.params.groupType});
      }else  {
        this.isLoadingResources = true
        this.$store.commit("base/setLoadingPage", true);
        this.$store.dispatch('user/getResourceByType', {type: this.$route.params.groupType})
          .then(res => {
            this.isLoadingResources = false
            this.$store.commit("base/setLoadingPage", false);
          }).catch(err => {
            this.$store.commit("base/setLoadingPage", false);
            this.isLoadingResources = false
          });
      }
  }
}
</script>
